import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useLazyUserBookingsQuery,
  useLazyUserDetailsQuery,
  useLazyUserWalletTransactionsQuery,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";
import UserBooking from "./UserBooking";
import UserDetails from "./UserDetails";
import UserWalletTransaction from "./UserWalletTransaction";

const User = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [tab, setTab] = useState(1);
  const [bookingPage, setBookingPage] = useState(1);
  const [walletPage, setWalletPage] = useState(1);
  const [bookingCount, setBookingCount] = useState(1);
  const [paginationBooking, setPagonationBooking] = useState({});
  const [rowBooking, setRowBooking] = useState(10);
  const [bookingStatus, setBookingStatus] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [bookingCurrentStatus, setBookingCurrentStatus] = useState("");
  const [bookingSearch, setBookingSearch] = useState("");

  const [walletCount, setWalletCount] = useState(1);
  const [paginationWallet, setPagonationWallet] = useState({});
  const [fromDateWallet, setFromDateWallet] = useState("");
  const [toDateWallet, setToDateWallet] = useState("");
  const [searchWallet, setSearchWallet] = useState("");

  const [details, setDetails] = useState({});
  const [bookings, setBookings] = useState([]);
  const [wallets, setWallets] = useState([]);

  // RTK QUERY
  const [userBookingsApi] = useLazyUserBookingsQuery();
  const [userDetailssApi] = useLazyUserDetailsQuery();
  const [userWalletTransactionApi] = useLazyUserWalletTransactionsQuery();

  const getDetatils = () => {
    dispatch(saveLoader(true));
    userDetailssApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setDetails(res?.user);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getDetatils();
    }
  }, []);

  const getBookings = (category, status, current, search) => {
    let params = `?page=${bookingPage}`;

    if (search) {
      params += `&search=${search}`;
    }

    if (current) {
      params += `&current=${current}`;
    }

    if (status) {
      params += `&status=${status}`;
    }

    if (category) {
      params += `&category=${category}`;
    }

    setServiceType(category);
    setBookingStatus(status);
    setBookingCurrentStatus(current);
    setBookingSearch(search);
    dispatch(saveLoader(true));
    userBookingsApi({ id: location?.state?.data?.id, params: params })
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBookings(res?.user_bookings);
        setBookingCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonationBooking(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getBookings(
        serviceType,
        bookingStatus,
        bookingCurrentStatus,
        bookingSearch
      );
    }
  }, [bookingPage]);

  const getWalletTransaction = (from_date, to_date, search) => {
    let params = `?page=${walletPage}`;

    if (search) {
      params += `&search=${search}`;
    }

    if (from_date) {
      params += `&from_date=${moment(from_date).format("YYYY-MM-DD")}`;
    }

    if (to_date) {
      params += `&to_date=${moment(to_date).format("YYYY-MM-DD")}`;
    }

    setFromDateWallet(from_date);
    setToDateWallet(to_date);
    setSearchWallet(search);
    dispatch(saveLoader(true));
    userWalletTransactionApi({ id: location?.state?.data?.id, params: params })
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setWallets(res?.user_wallets);
        setWalletCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonationWallet(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getWalletTransaction(fromDateWallet, toDateWallet, searchWallet);
    }
  }, [walletPage]);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"user"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-12">
              <div className="nav-user">
                <div className="presentation">
                  <button
                    className={`nav-presentation  ${
                      tab == 1 ? "pre-active" : ""
                    }`}
                    onClick={() => setTab(1)}
                  >
                    Details
                  </button>
                </div>
                <div className="presentation">
                  <button
                    className={`nav-presentation  ${
                      tab == 2 ? "pre-active" : ""
                    }`}
                    onClick={() => setTab(2)}
                  >
                    Bookings
                  </button>
                </div>
                <div className="presentation">
                  <button
                    className={`nav-presentation  ${
                      tab == 3 ? "pre-active" : ""
                    }`}
                    onClick={() => setTab(3)}
                  >
                    Wallet Transactions
                  </button>
                </div>
              </div>
              <div>
                {tab == 1 && <UserDetails details={details} />}
                {tab == 2 && (
                  <UserBooking
                    bookingCount={bookingCount}
                    setBookingPage={setBookingPage}
                    bookings={bookings}
                    paginationBooking={paginationBooking}
                    rowBooking={rowBooking}
                    getBookings={getBookings}
                    bookingStatus={bookingStatus}
                    serviceType={serviceType}
                    bookingCurrentStatus={bookingCurrentStatus}
                    bookingSearch={bookingSearch}
                  />
                )}
                {tab == 3 && (
                  <UserWalletTransaction
                    wallets={wallets}
                    paginationWallet={paginationWallet}
                    walletCount={walletCount}
                    setWalletPage={setWalletPage}
                    getWalletTransaction={getWalletTransaction}
                    fromDateWallet={fromDateWallet}
                    toDateWallet={toDateWallet}
                    searchWallet={searchWallet}
                  />
                )}
              </div>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default User;
